import { Skeleton } from '@/components/ui/skeleton'

export const ViewAppButtonFallback = () => {
  return <Skeleton className="h-9 w-21 ml-auto" />
}
